export async function putPdfFileToS3Service(signedUrl, file) {
  console.log('IMAGE FILE', file);
  const response = await fetch(signedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      // 'Content-Type': 'application/pdf',
      'Content-Type': 'image/jpeg',
    },
  });

  return response;
}
